<template>
	<header class="wc-header">
		<div class="wc-wrapper">
			<NuxtLink to="/" class="logo"></NuxtLink>
		</div>
	</header>

	<div class="wc-main wc-wrapper">
		<slot />
	</div>

	<footer class="wc-footer">
		<div class="wc-footer-row wc-footer-row1">
			<div class="wc-wrapper wc-footer-row1-inner">
				<div class="wc-footer-title"><BaseCmsLabel code="wc_support" /></div>
				<div class="wc-footer-support wc-footer-support-tel">
					<div class="wc-footer-support-title"><BaseCmsLabel code="wc_support_tel_note" /></div>
					<BaseCmsLabel code="support_tel" tag="div" class="wc-footer-support-info tel" />
				</div>
				<div class="wc-footer-support wc-footer-support-mail">
					<div class="wc-footer-support-title"><BaseCmsLabel code="wc_support_mail_note" /></div>
					<BaseCmsLabel code="support_email" tag="div" class="wc-footer-support-info mail" />
				</div>
				<div class="wc-footer-support wc-footer-support-hours">
					<div class="wc-footer-support-title"><BaseCmsLabel code="wc_support_working_hours_note" /></div>
					<BaseCmsLabel code="support_working_hours" tag="div" class="wc-footer-support-info" />
				</div>
			</div>
		</div>
		<div class="wc-footer-row wc-footer-row2 wc-wrapper">
			<div class="wc-footer-col wc-footer-col1">
				<div class="copy wc-copy"><BaseCmsCopyright label="copyright" /></div>
				<div class="wc-footer-info"><BaseCmsLabel code="copyright_extra" /></div>
			</div>
			<div class="wc-footer-col wc-footer-col2">
				<BaseCmsLabel code="footer_badges" tag="span" />
				<div class="wc-footer-trustmark smdWrapperTag"></div>
			</div>
		</div>
		<ClientOnly>
			<CmsEu />
		</ClientOnly>
	</footer>
</template>

<script setup>
	onMounted(() => {
		// certificated shop script
		var smdWrapper = document.createElement("script"), smdScript;
		smdWrapper.async = true;
		smdWrapper.type = "text/javascript";
		smdWrapper.src = "https://cpx.smind.si/Log/LogData?data=" + JSON.stringify({
			Key: "Slo_862",
			Size: "80",
			Type: "badge",
			Version: 2,
			BadgeClassName: "smdWrapperTag"
		});
		smdScript = document.getElementsByTagName("script")[0];
		smdScript.parentNode.insertBefore(smdWrapper, smdScript);
	})
</script>

<style lang="less">
	.floating-labels-checkout{
		p{padding: 0;}
		.input-field{
			margin-bottom: 30px; position: relative;
			&:before{.pseudo(auto,2px); left: 0; right: 0; bottom: 0; opacity: 0; z-index: -1; .transition(all);}
			&.field-success:before{background: @blue; opacity: 1; z-index: 1;}
			&.field-error:before{background: @red2; opacity: 1; z-index: 1;}
			label{
				padding: 0; font-size: 16px; color: @inputTextColor; position: absolute; top: 16px; left: 20px; opacity: 1; transition: all 0.2s ease-out;

				@media (max-width: @ms){left: 15px;}
			}
			&.floated-label{
				input{padding-top: 15px;}
				input ~ label:first-of-type, textarea ~ label:first-of-type{font-size: 12px; top: 7px;}
				textarea{padding-top: 25px;}
			}

			@media (max-width: @m){
				margin-bottom: 25px;
				label{top: 15px;}
			}
		}
		.field_error_input, .field_error_input_radio{border-color: @borderColor;}

		.error{
			display: block; padding: 0; line-height: 1; color: @red2; position: absolute; left: 20px; top: calc(~"100% - -5px");
			@media (max-width: @ms){left: 15px;}
		}
	}
</style>

<style lang="less" scoped>
	.page-webshop-login, .page-webshop-thank_you{
		.wc-main{margin: 0 auto;}
	}
	.wc-wrapper{
		width: 1360px; margin: 0 auto;

		@media (max-width: @l){width: auto; margin: 0 3%;}
		@media (max-width: @m){margin: 0 15px;}
	}
	:deep(.wc-form){
		display: flex; align-items: flex-start;

		@media (max-width: @m){display: block;}
	}
	:deep(.wc-form-col1){
		flex-grow: 1; margin-right: 65px;

		@media (max-width: @m){margin-right: 0;}
	}
	:deep(.wc-title){
		margin: 0 0 7px; padding: 0; font-size: 25px; font-weight: 600;
		&.special{
			display: flex; align-items: center; margin-bottom: 20px;
			img{width: auto; height: auto; max-width: 50px; max-height: 50px; display: block; margin-right: 15px;}
		}

		@media (max-width: @m){
			font-size: 19px; line-height: 1.3;
			&.special{
				margin-bottom: 15px;
				img{max-width: 36px; max-height: 36px; margin-right: 10px;}
			}
		}
	}
	:deep(.wc-info){padding-bottom: 13px; font-size: 15px;}
	:deep(.btn-spinner){
		pointer-events: none;
		&:before{content: ""; width: 40px; height: 40px; background: url(assets/images/loader.svg) no-repeat center; background-size: 40px; z-index: 1;}
	}

	.wc-header{
		display: block; width: 100%; background: linear-gradient(270deg, #0184BF 0%, #005CAC 100%); z-index: 9999;
		&>.wc-wrapper{
			display: grid; align-items: center; height: 60px; position: relative;
			@media (max-width: @m){height: 50px;}
		}
	}
	.logo{
		display: flex; align-items: center; justify-content: center; flex-shrink: 0; width: 123px; height: 26px; background: url('/images/logo.svg') no-repeat; background-size: contain; top: unset; left: unset; z-index: 1;
		@media (max-width: @m){height: 20px; left: 0;}
	}

	.wc-footer{
		margin-top: 70px; border-top: 1px solid @borderColor; position: relative;
		@media (max-width: @m){margin-top: 25px;}
	}
	.wc-footer-row1{
		width: 100%; padding: 35px 0; background: @lightGray; border-bottom: 1px solid @borderColor;
		@media (max-width: @m){padding: 20px 0 15px;}
	}
	.wc-footer-row1-inner{
		display: flex; align-items: center; justify-content: space-between;
		@media (max-width: @m){display: block;}
	}
	.wc-footer-title{
		padding-right: 15px; font-size: 21px; font-weight: 600;
		@media (max-width: @m){font-size: 19px; padding-bottom: 15px;}
	}
	.wc-footer-support{
		display: block; padding-left: 60px; font-size: 16px; position: relative;
		@media (max-width: @m){padding-bottom: 15px; line-height: 1.3; padding-left: 50px;}
		&:before{line-height: 1; font-family: @fonti; color: @blue; position: absolute; top: 5px; left: 0;}
	}
	.wc-footer-support-tel:before{
		.icon-support3(); font-size: 44px;
		@media (max-width: @m){font-size: 36px;}
	}
	.wc-footer-support-mail:before{
		.icon-email(); font-size: 40px;
		@media (max-width: @m){font-size: 32px;}
	}
	.wc-footer-support-hours{
		margin-bottom: 0;
		&:before{
			.icon-time(); font-size: 38px;
			@media (max-width: @m){font-size: 33px;}
		}
	}
	.wc-footer-support-title{
		padding-bottom: 2px; font-size: 15px; font-weight: 600;
		@media (max-width: @m){font-size: 14px; line-height: 1.3;}
	}
	.wc-footer-support-info{
		&.tel :deep(a){
			font-size: 21px; font-weight: 600; color: @blue; text-decoration: none;
			@media (max-width: @m){font-size: 19px;}
		}
		:deep(a){
			color: @textColor; text-decoration: underline; text-decoration-color: @blue; text-underline-offset: 2px;
			&:hover{text-decoration: none;}
		}
	}
	.wc-footer-row2{
		display: flex; align-items: center; justify-content: space-between; padding: 35px 0;
		@media (max-width: @m){display: block; padding: 25px 0 20px;}
	}
	.wc-copy{font-size: 13px;}
	.wc-footer-info{font-size: 13px; margin-top: 6px; color: @inputTextColor;}
	.wc-footer-col2{
		display: flex; align-items: center; flex-wrap: wrap;
		@media (max-width: @m){padding-top: 20px;}
		p{
			display: flex; align-items: center; padding: 0!important;
			&>*{margin-right: 10px;}
		}
		a{display: flex;}
		img{
			width: auto; height: auto; max-width: 150px; max-height: 70px; display: block;
			@media (max-width: @m){max-height: 65px;}
		}
		&>*{
			margin: 0 10px 10px 0;
			&:last-child{margin-right: 0;}
		}
	}


	/*------- error message -------*/
	:deep(.unavailable-item){max-width: 1100px; margin: 0 auto;}
	:deep(.unavailable-item){
		display: flex; justify-content: space-between; border: 1px solid @red2; padding: 18px 25px; margin-top: -1px;
		@media (max-width: @m){padding: 13px 15px; display: block;}
		&.special{margin: 0 0 25px;}
		&:last-child{margin-bottom: 20px;}

		.title{
			padding-left: 30px; font-size: 15px; position: relative; font-weight: bold;
			&:before{
				.icon-available-last(); font: 17px/1 @fonti; color: @red2; position: absolute; top: 1px; left: 0;
				@media (max-width: @m){font-size: 15px; top: 4px;}
			}
			&.special:before{.icon-unavailable(); font-size: 15px; top: 3px; left: 2px;}
			@media (max-width: @m){
				padding-left: 25px; padding-bottom: 3px; font-weight: normal;
				&.special:before{top: 4px;}
			}
		}
		.price{
			display: block; margin-top: 10px; font-weight: bold;
			&>:first-child{margin-right: 5px;}
		}
		.btns{
			display: flex;
			&>*:last-child{
				margin-left: 10px; padding-left: 10px; position: relative;
				&:before{.pseudo(1px,10px); background: @red2; left: 0;}
			}
		}
		.btn-edit-items{
			display: flex; align-items: center; font-size: 15px; font-weight: 600; color: @red2; text-decoration: underline; text-underline-offset: 1px; cursor: pointer; position: relative;
			&.special{
				padding-right: 25px;
				&:after{.icon-trash(); font: 17px/1 @fonti; position: absolute; right: 0;}
			}
			&:hover{text-decoration: none;}

			@media (max-width: @m){
				font-size: 14px; display: block; text-align: right;
				&.special:after{top: 3px;}
			}
		}
		.btn-hidde{
			display: flex; align-items: center; flex-shrink: 0; margin-left: 20px; font-size: 15px; font-weight: 600; color: @red2; text-decoration: underline; text-underline-offset: 1px; cursor: pointer; position: relative;
			&:hover{text-decoration: none;}
		}
		@media (max-width: @m){
			.label{font-weight: bold;}
			.value{display: block; margin-left: -25px;}
		}
	}
	/*------- /error message -------*/

	/*------- thank you -------*/
	:deep(.thank-you){
		width: 680px; margin: 45px auto 50px; font-size: 16px;
		@media (max-width: @m){width: auto; margin: 0; padding: 25px 15px 0;}
	}
	:deep(.thank-you-title){
		display: block; margin-bottom: 20px; padding: 0 0 0 42px; font-size: 25px; line-height: 1.2; position: relative;
		@media (max-width: @m){font-size: 19px; line-height: 1.2; margin-bottom: 15px;}
		&:before{
			.icon-available(); font: 30px/1 @fonti; color: @blue; position: absolute; left: 0;
			@media (max-width: @m){font-size: 28px; top: -2px;}
		}
		&.special:before{.icon-available-last(); font-size: 25px; color: @red2;}

		@media (max-width: @m){
			&.special:before{font-size: 22px;}
		}
	}
	:deep(.thank-you-desc-email){
		@media (max-width: @m){line-height: 1.5;}
	}

	:deep(.thank-you-continue){
		display: flex; justify-content: flex-end; margin-top: 35px;
		@media (max-width: @m){margin-top: 25px; justify-content: flex-start;}
	}
	:deep(.thank-you-continue-btn){
		padding-right: 15px; font-size: 15px; font-weight: 600; color: @blue; text-decoration: none; cursor: pointer; position: relative;
		&:before{
			.icon-arrow(); font: 10px/10px @fonti; font-weight: 600; color: @blue; position: absolute; top: 6px; right: 0; .rotate(180deg); .transition(right);
			@media (max-width: @m){top: 8px;}
		}
		&:hover{
			color: @blue; text-decoration: none;
			&:before{right: -5px;}
		}
	}

	:deep(.thank-you-support){
		display: flex; justify-content: center; flex-direction: column; margin: 10px 0 35px; padding: 25px 20px 15px; background: #F3F6FA;
		@media (max-width: @m){font-size: 15px; padding: 15px 15px 5px; margin-bottom: 0; line-height: 1.4;}
		h2,h3,h4{display: block; margin: 0 0 5px; padding: 0; font-size: 19px; line-height: 1.2;}
	}


	:deep(.thank-you-section){background: #F0F2F4; padding: 50px 0 90px;}
	:deep(.thank-you-box){width: 1000px; margin: 0 auto; padding: 50px 140px; background: @white;}
	/*------- /thank you -------*/
</style>
